import { render, staticRenderFns } from "./VideoStreamPage.vue?vue&type=template&id=27a6751c&scoped=true"
import script from "./VideoStreamPage.vue?vue&type=script&lang=js"
export * from "./VideoStreamPage.vue?vue&type=script&lang=js"
import style0 from "./VideoStreamPage.vue?vue&type=style&index=0&id=27a6751c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a6751c",
  null
  
)

export default component.exports